import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiCall from '../../Util/apiCall';

export const saveCounter = createAsyncThunk(
    "counter/saveCounter",
    async (obj) => {
        const response = await apiCall.post("api/about-db/counter/save", {
            title: obj.title,
            count: obj.count,
            is_active: obj.is_active,
            type: obj.type,
            year: obj.type === 'GOOGLE_SCHOLAR' ? obj.year : undefined,
            sequence_no: obj.type === 'RESEARCH_GATE' ? obj.sequence_no : undefined
        });
        return response.data;
    }
);

const counterSlice = createSlice({
    name: 'counter',
    initialState: {
        counter: {
            title: "",
            count: 0,
            is_active: true,
            type: "GOOGLE_SCHOLAR",
            year: new Date().getFullYear(),
            sequence_no: 1
        },
        success: false,
        error: null
    },
    reducers: {
        setCounter: (state, {payload}) => {
            state.counter = {
                title: "",
                count: 0,
                is_active: true,
                type: "GOOGLE_SCHOLAR",
                year: new Date().getFullYear(),
                sequence_no: 1
            }
        }
    },
    extraReducers: {
        [saveCounter.pending]: (state) => {
            state.success = false;
            state.error = null;
        },
        [saveCounter.rejected]: (state) => {
            state.success = false;
            state.error = "Failed to save counter";
        },
        [saveCounter.fulfilled]: (state, {payload}) => {
            state.success = true;
            state.error = null;
        }
    }
});

export const {setCounter} = counterSlice.actions;
export const getCounter = (state) => state?.counter?.counter || {
    title: "",
    count: 0,
    is_active: true,
    type: "GOOGLE_SCHOLAR",
    year: new Date().getFullYear(),
    sequence_no: 1
};

export default counterSlice.reducer;
